import {useDispatch} from "react-redux";
import ModalBody from "../../../core/Modal/ModalBody/ModalBody";
import ModalHeader from "../../../core/Modal/ModalHeader/ModalHeader";
import {closeLobbyModal} from "../../../redux/actions/lobby/actions";
import HowToPlay from "../../Lobby/HowToPlay/index.jsx";
import {useTranslation} from "react-i18next";

function HowToPlayModal() {
    const dispatch = useDispatch()
    const {t} = useTranslation();

    return <>
        <ModalHeader>
            <div className="how-to-play__header">
                <p>{t("mobile_side_menu.how_to_play")}</p>
                <i className="icon-close" onClick={() => dispatch(closeLobbyModal())}/>
            </div>
        </ModalHeader>
        <ModalBody>
            <HowToPlay/>
        </ModalBody>
    </>
}

export default HowToPlayModal